import { LoginComponent } from './components/auth/login/login.component';
import { DefaultLayoutComponent } from './components/layout/default-layout/default-layout.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { AuthGuardGuard } from './services/auth-guard.guard';
import { UserPreferenceComponent } from './components/enviornment-selection/user-preferences/user-preference.component';

const routes: Routes = [
  {
    path: '',
    component: LoginComponent
  },
  {
    path: 'home',
    component: HomeComponent
  },
  {
    path: 'auth',
    loadChildren: () => import('./components/auth/auth.module').then(m => m.AuthModule),
  },
  {
    path: 'preferences/change-preferences',
    component: UserPreferenceComponent
  },
  {
    path: 'aggregation',
    component: DefaultLayoutComponent,
    canActivate: [AuthGuardGuard],
    children: [
      { path: 'command-workflow', loadChildren: () => import('./components/modules/operational-reports/operational-reports.module').then(m => m.OperationalReportsModule) },
      { path: 'fixed-files-reports', loadChildren: () => import('./components/modules/fixed-files/fixed-files.module').then(m => m.FixedFilesModule) },
      { path: 'process-management', loadChildren: () => import('./components/modules/process-management/process-management.module').then(m => m.ProcessManagementModule) },
      { path: 'payer-management', loadChildren: () => import('./components/modules/bi-reports/bi-reports.module').then(m => m.BIReportsModule) },
      { path: 'configuration', loadChildren: () => import('./components/modules/configuration/configuration.module').then(m => m.ConfigurationModule) }
    ],
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes)
  ],
  exports: [
    RouterModule
  ],
  providers: [AuthGuardGuard]
})
export class AppRoutingModule { }
